export default __webpack_public_path__ + "static/media/Lato-Bold.8853a16d.woff2";